module.exports = __webpack_public_path__ + "img/infoQRView.b90f269e.svg";